import "../../../assets/css/milestone.css";
import React, { useState, useContext } from "react";
import image from "../../../assets/images/search.png";
import MockMessageComponent from "./MockMessageComponent";
import MockTooltipComponent from "../MockTooltipComponent";
import makeStyles from "@material-ui/core/styles/makeStyles";
import  Typography  from "@material-ui/core/Typography";
import { userJourneyContext } from "../../../states/context/userJourneyContext";

const MockCommunicationHistory = (props) => {
  const [searchText, setSearchText] = useState("");
  const onSearchTextChangeHandler = (event) => {
    setSearchText(event.target.value);
  };
  const classes = useStyles();
  const userContext = useContext(userJourneyContext);

  React.useEffect(() => {
    if (userContext.userJourneyInfo.payload.steps === 12) {
      window.scrollTo({ top: 200, left: 0, behavior: 'smooth' });
    }
  }, [userContext.userJourneyInfo.payload.steps]);

  return (
    <>
      {" "}
      <div className="mainHeader-component">
        <h4 className="communication-heading">Communications History</h4>
        <div>
          <form>
            <div className="search-container">
              <input
                className="search-input"
                type="search"
                placeholder="Search Mail"
                value={searchText}
                onChange={onSearchTextChangeHandler}
              />
              <img className="search-icon" src={image} />
            </div>
          </form>
        </div>
      </div>
      <p className="contact-info-msg">
        View your entire communications history with your supplier, or select a
        contact on the left.
      </p>
      <div className="compose_email">
        <div
          className="messageChannelDiv"
        >
          <MockTooltipComponent
            placement="top-start"
            open={props.openComposeEmail && !props.openEmail}
            popper={classes.composeEmailPopperTooltip}
            title={
              <>
                <Typography className={classes.tooltipTitleStyle}>
                Click Compose Email
                </Typography>
                <p className={classes.tooltipTextStyle}>
                  It’s time to write your supplier an email to ask for
                  an update on the order.
                </p>
                <Typography className={classes.stepTextStyle}>
                  (9/19)
                </Typography>
              </>
            }
            child={
              <button
                className="btn"
                onClick={() => {
                  if (userContext.userJourneyInfo.payload.steps === 12) {
                    props.setOpenEmail(true);
                    props.makeApiCall();
                  }
                }}
              >
                <img
                  src={require(`../../../assets/images/compose_email.png`).default}
                />
                <span className="btn-text">Compose Email</span>
              </button>
            }
          />
          <button
            className="btn btn-whatsapp"
          >
            <img src={require(`../../../assets/images/whatsapp.png`).default} />
            <span className="btn-text">Whatsapp</span>
          </button>
        </div>
        <MockMessageComponent beforeEmail={props.beforeEmail} />
      </div>
    </>
  );
};
export default MockCommunicationHistory;

const useStyles = makeStyles((theme) => ({
  composeEmailPopperTooltip: {
    zIndex: "1",
    marginTop:"20px",
    marginLeft:"-20px"
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: 600,
    marginBottom: "8px",
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
    fontWeight: 400,
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  }
}));